module.exports = __webpack_public_path__ + "static/media/Ranger_Next-Gen.2399183a.png";